/** A "How this is calculated" link that opens the explanation in a side drawer - ADR-0212 decision 2.
 *
 * For text that is longer than a popover wants to be: a method, a basis, a list of limits. Like
 * `InfoPopover` it takes a **key into `shell/infoText.ts`** and never text, so the explanation has
 * one home that Help can list. The drawer is the product's own (`Drawer`): modal, focus trapped,
 * Escape and the scrim close it, and focus goes back to the link that opened it. Closed, nothing of
 * its text is in the document.
 */

import { Info } from "@phosphor-icons/react";
import { useState } from "react";

import type { InfoKey } from "../../shell/infoText";
import { infoEntry } from "../../shell/infoText";
import { Drawer } from "./Drawer";
import styles from "./HowDrawer.module.css";

export function HowDrawer({
  infoKey,
  label = "How this is calculated",
}: {
  infoKey: InfoKey;
  /** The link's words. */
  label?: string;
}) {
  const entry = infoEntry(infoKey);
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={styles.link}
        aria-haspopup="dialog"
        data-info-key={infoKey}
        onClick={() => setOpen(true)}
      >
        <Info size={14} weight="bold" aria-hidden="true" />
        {label}
      </button>
      <Drawer open={open} onClose={() => setOpen(false)} title={entry.title} width="sm">
        <div className={styles.body}>
          {entry.body.map((paragraph) => (
            <p key={paragraph} className={styles.text}>
              {paragraph}
            </p>
          ))}
        </div>
      </Drawer>
    </>
  );
}
